import { FC, useState } from 'react'
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Attribute, AttributeLabel, AttributeValue } from 'packages/eid-ui'
import { ApplicationUserCard } from '../UserCard'
import { useTranslation } from 'react-i18next'
const smallScreenWidth = 960

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            position: 'relative',
            padding: theme.spacing(2),
            display: 'flex',
            miHeight: '156px',
            justifyContent: 'space-between',

            [`@media (max-width:${smallScreenWidth - 1}px)`]: {
                flexDirection: 'column',
            },
        },
        paddingdiv: {
            padding: '0 20px',
            width: '100%',
        },
        heading: {},
        result: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        showmore: {
            fontSize: '13px',
            margin: '0',
            marginTop: '2px',
            color: theme?.palette?.primary?.main,
            cursor: 'pointer',
        },
        showless: {
            fontSize: '13px',
            margin: '0',
            marginTop: '2px',
            color: theme?.palette?.primary?.main,
            cursor: 'pointer',
        },
    }),
)

export const ApplicationOwnerDeputies: FC<any> = ({ label, data }) => {
    const classes = useStyles()
    const { t } = useTranslation()

    const noOfItems = 2
    const [showMore, setShowMore] = useState(
        data.length > noOfItems ? true : false,
    )

    const bindUserInfo = (users: any) => {
        if (users && users.length > 0) {
            if (showMore) {
                // eslint-disable-next-line
                return users.map((item: any, index: number) => {
                    if (index < noOfItems)
                        return (
                            <ApplicationUserCard
                                key={`application-apprvers-${index}`}
                                data={item}
                            />
                        )
                })
            } else {
                return users.map((item: any, index: number) => (
                    <ApplicationUserCard
                        key={`application-apprvers-${index}`}
                        data={item}
                    />
                ))
            }
        } else {
            return '-'
        }
    }

    return (
        <Attribute orientation="horizontal">
            <AttributeLabel className={classes.heading}>{label}</AttributeLabel>
            <AttributeValue className={classes.result}>
                {bindUserInfo(data)}{' '}
                {showMore ? (
                    <p
                        onClick={() => setShowMore(!showMore)}
                        className={classes.showmore}
                    >
                        + {data.length - noOfItems} {t('Common_More')}
                    </p>
                ) : (
                    data.length > noOfItems && (
                        <p
                            onClick={() => setShowMore(!showMore)}
                            className={classes.showless}
                        >
                            {t('Common_ShowLess')}
                        </p>
                    )
                )}
            </AttributeValue>
        </Attribute>
    )
}
